import React from "react";
import Footer from "../pages/Footer";
import Portfoliodetail2 from "../components/portfoliosub2";
import "../App.css"; // if needed for global styles

export default function PortfolioDetails() {
  return (
    <div className="App">
      <Portfoliodetail2 />
      {/* 📱 Service 6 - Footer with WhatsApp */}
<div className="whatsapp-wrapper d-flex justify-content-center">
  <div className="whatsapp-section text-center py-5 px-4">
    <h3 className="fw-bold mb-3 text-white">
      Chat with Us on WhatsApp <br /> Get Instant Support
    </h3>
    <div className="d-flex justify-content-center">
      <a
        href="https://wa.me/94771234567" // replace with your WhatsApp number
        target="_blank"
        rel="noopener noreferrer"
        className="btn whatsapp-btn fw-bold px-4 py-2 d-flex align-items-center gap-2"
      >
      <i className="fa-brands fa-whatsapp"></i>
        Chat Now
      </a>
    </div>
  </div>
</div>

{/* Footer */}
<Footer />


    </div>
  );
}
